import { createContext } from 'react';

const context = createContext();

export const Provider = context.Provider;
export const Consumer = context.Consumer;

export default { Provider, Consumer };
